import { AuthTypeValues } from '../../types/types';

export function buildAuthSecretName(
  authTypeValue: AuthTypeValues | undefined,
  authenticationVersion: string | undefined
): string {
  let secretName = 'DefaultClientSecret';
  if (authTypeValue === AuthTypeValues.OAUTH2) {
    secretName = 'OAuth2ClientSecret';
  } else if (authTypeValue === AuthTypeValues.ENTRAID) {
    secretName = 'EntraIdClientSecret';
  } else if (authTypeValue === AuthTypeValues.OPENIDCONNECT) {
    secretName = 'OpenIdClientSecret';
  }

  return authenticationVersion ? `${authenticationVersion}${secretName}` : secretName;
}
